/* eslint-disable import/no-cycle */
import Image from './image';
import Product from './product';
import Video from './video';

class Collection {
  constructor({
    id,
    attributes: {
      title,
      slug,
      description,
      image,
      products,
      createdAt,
      updatedAt,
      publishedAt,
      video,
    },
  }) {
    this.id = id;
    this.title = title;
    this.slug = slug;
    this.description = description;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.publishedAt = publishedAt;

    if (!!image && image.data) {
      this.image = new Image(image.data);
    }

    if (!!video && video.data) {
      this.video = new Video(video.data);
    }

    if (products?.data) {
      this.products = products.data
        .map((prod) => new Product(prod))
        .filter((n) => Object.keys(n).length > 0);
    }
  }
}

export default Collection;
